import { type RouteObject } from 'react-router';
import { RoutesList } from '../../config/routes-list';
import MainLayout from '../../layouts/MainLayout';
import { lazyRoute } from '../lazy-route';

const regulatoryNewsPageRoute = lazyRoute(() => import('../../pages/regulatory-news/main-page'));

export const regulatoryNewsRoutes: RouteObject[] = [
  {
    path: RoutesList.REGULATORY_NEWS,
    element: <MainLayout />,
    children: [
      { index: true, ...regulatoryNewsPageRoute },
      // Deep link target for in-app/email recall alerts: /regulatory-news/:id
      { path: ':id', ...regulatoryNewsPageRoute },
    ],
  },
];
